import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import {AppBar, IconButton, Toolbar, Grid, Typography, Tooltip} from '@material-ui/core';
import {Menu as MenuIcon} from '@material-ui/icons';
import {useStyles} from 'util/Styles';

function MyOzgeneToolbar(props) {
  const {onOpenDrawer, drawerOpen, classes} = props;

  return (
    <AppBar position="absolute" className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}>
      <Toolbar className="login_bg">
        {!drawerOpen && (
          <Tooltip title="expand">
            <IconButton onClick={onOpenDrawer}>
              <MenuIcon style={{color: 'white'}} />
            </IconButton>
          </Tooltip>
        )}

        <a href="/#/Projects/" style={{textDecoration: 'none'}}>
          <Typography variant="h5" style={{color: 'white'}}>
            myOzgene
          </Typography>
        </a>
      </Toolbar>
    </AppBar>
  );
}

MyOzgeneToolbar.propTypes = {
  onOpenDrawer: PropTypes.func.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
};

export default MyOzgeneToolbar;
